import { create } from "zustand";

interface ProcessState {
  status: "delete" | "cancel" | undefined;
  popupStatus: boolean;
  title: string | undefined;
  description: string | undefined;
  id: string | undefined;
  identity: string | undefined;
  onDelete: (prop: {
    popupStatus: boolean;
    title: string;
    description: string;
    id: string;
    identity: string;
  }) => void;
  onDeleteResponse: (prop: "delete" | "cancel") => void;
  clearDelete: () => void;
}

export const useDeletePopup = create<ProcessState>((set) => ({
  status: undefined,
  popupStatus: false,
  title: undefined,
  description: undefined,
  id: undefined,
  identity: undefined,
  onDelete: (value) =>
    set(() => ({
      popupStatus: value.popupStatus,
      title: value.title,
      description: value.description,
      id: value.id,
      identity: value.identity,
    })),
  onDeleteResponse: (value) => set(() => ({ status: value })),
  clearDelete: () =>
    set(() => ({
      status: undefined,
      popupStatus: false,
      title: undefined,
      description: undefined,
      id: undefined,
      identity: undefined,
    })),
}));
